var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0375 23.5254C18.275 23.5254 18.5125 23.4379 18.7 23.2504L26.2875 15.6629C26.65 15.3004 26.65 14.7004 26.2875 14.3379L18.7 6.75039C18.3375 6.38789 17.7375 6.38789 17.375 6.75039C17.0125 7.11289 17.0125 7.71289 17.375 8.07539L24.3 15.0004L17.375 21.9254C17.0125 22.2879 17.0125 22.8879 17.375 23.2504C17.55 23.4379 17.8 23.5254 18.0375 23.5254Z",
    fill: "#484EA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3751 15.9375H25.4126C25.9251 15.9375 26.3501 15.5125 26.3501 15C26.3501 14.4875 25.9251 14.0625 25.4126 14.0625H4.3751C3.8626 14.0625 3.4376 14.4875 3.4376 15C3.4376 15.5125 3.8626 15.9375 4.3751 15.9375Z",
    fill: "#484EA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrowRight);
export default __webpack_public_path__ + "static/media/slider-arrow-right.0965732010550958acd2ea30836ab5f7.svg";
export { ForwardRef as ReactComponent };